var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Header'),_c('Home',{attrs:{"account-id":_vm.accountId,"page-size":_vm.pageSize,"template-id":_vm.templateId,"include-past":_vm.includePast,"only-past":_vm.onlyPast}}),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }